/**
 *  微信分享 打开小程序
*/
import dot from "dot";

import "./style.less";
let tpl = require("./index.html");

export default function shareWechat(opt:any) {
  let defaultOpt = {
    imgsrc:""
  };

  let option = $.extend({}, defaultOpt,opt);

  if (!option.imgsrc)return false;

  let htmlstr = dot.template(tpl)({
    imgsrc: option.imgsrc
  })

  $("body").append(htmlstr);

  $(".share_weixin_xcx_close").click(function () {
    $(".share_weixin_xcx").hide();
  })
};

